import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import SearchIcon from "@mui/icons-material/Search";
import ListSubheader from "@mui/material/ListSubheader";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import FavoriteBorder from "@mui/icons-material/StarBorder";
import Favorite from "@mui/icons-material/Star";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { esES } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import {
  DEFAULT_AVATAR_URL,
  EntityFavoriteStatus,
  RegistrationStatus,
} from "../../common/enum";
import {
  getEntitiesList,
  setEntitiesLimit,
  setEntitiesOffset,
} from "../AdminView/adminSlice";
import { debounce } from "lodash";
import { Avatar, Button } from "@mui/material";
import Loader from "../../components/Loader";
import { LoadingButton } from "@mui/lab";
import { addEntityFavorite, getEntityFavorites } from "./slice";
import { useSnackbar } from "notistack";
import { setCollectorInviteNames } from "../DonationView/slice";

const FavoriteEntity = ({ personName, setPersonName, t , isBlacklist}) => {
  const {
    auth: {
      user: { userId, entityId },
      profile: { entity },
    },
    collectorInvite: { loading, entitiesFavorites },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const timer = React.useRef(null);
  const [searchText, setSearchText] = React.useState("");
  const [searchFavoriteEntities, setSearchFavoriteEntities] = React.useState(
    []
  );

  const getFavoriteEntities = React.useCallback(() => {
    const payload = {
      entityId: userId,
      status: EntityFavoriteStatus.favorite,
      isBlacklist: isBlacklist != null ? isBlacklist : false
    };
    dispatch(getEntityFavorites(payload));
  }, [dispatch, userId]);

  React.useEffect(() => {
    if (entitiesFavorites.length > 0) {
      setSearchFavoriteEntities((v) => [...v, ...entitiesFavorites]);
    }
  }, [entitiesFavorites]);

  React.useEffect(() => {
    setSearchFavoriteEntities([])
    getFavoriteEntities();
  }, []);

  const debouncedApiCall = debounce(async (value) => {
    dispatch(getEntityFavorites(value));
  }, 1000);

  const handleSerachBox = (event) => {
    setSearchFavoriteEntities([]);
    setSearchText(event.target.value);
    if (event.target.value.length > 0) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        let value = {
          entityId: userId,
          status: EntityFavoriteStatus.favorite,
          entityName: event.target.value,
          isBlacklist: isBlacklist != null ? isBlacklist : isBlacklist
        };
        debouncedApiCall(value);
      }, 1000);
    }
  };

  const handleCollectorName = (e, name) => {
//   const allPerson = personName.includes(name);
              //   if (allPerson) {
              //     const dat = personName.filter(
              //       (n) => n.entity.id !== name?.entity.id
              //     );
              //     setPersonName([...dat]);
              //   } else {
              //     setPersonName((v) => [...v, name]);



    const allPerson = personName.includes(name);
   
    if (allPerson) {
      const dat = personName.filter((n) => n.entity.id !== name?.entity.id);
      setPersonName([...dat]);
      dispatch(setCollectorInviteNames([...dat]));
    } else {
      setPersonName((v) => [...v, name]);
      dispatch(setCollectorInviteNames([...personName, name]));
    }
  };
  
const [profileImages, setProfileImages] = useState(new Map());

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of searchFavoriteEntities) {
      const id = item?.entity?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
          newMap.set(item.entity.entityId, imageUrl);
        }else{
            newMap.set(item.entity.entityId, DEFAULT_AVATAR_URL);
        }

      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [searchFavoriteEntities, dispatch]);


  return (
    <>
      <ListSubheader>
        <TextField
          size="small"
          sx={{
            mt: 1,
          }}
          // Autofocus on textfield
          autoFocus
          placeholder={t('typeToSearch')}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            sx: { borderRadius: 5 },
          }}
          onChange={handleSerachBox}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              // Prevents autoselecting item while typing (default Select behaviour)
              e.stopPropagation();
            } else if (e.key === "Enter") {
              handleSerachBox(e);
            }
          }}
        />
      </ListSubheader>
      {loading && <Loader t={t} />}
      {searchFavoriteEntities.length > 0 &&
        searchFavoriteEntities.map((name) => (
          <MenuItem
            key={name?.entity.entityId}
            value={name?.entity.entityName}
            //   style={getStyles(name?.entity.entityName, personName, theme)}
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Avatar
              src={
                name?.entity?.profilePicture !== "string"
                  ? profileImages.get(name?.entity.entityId)
                  : DEFAULT_AVATAR_URL
              }
              variant="rounded"
              sx={{ backgroundColor: "green", mr: 1 }}
            />
            <ListItemText primary={name?.entity.entityName} />
            <Checkbox
              checked={personName.find(
                (f) =>
                  f.entity.entityId === name?.entity.entityId 
                  
              )}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleIcon />}
              sx={{
                p: 0,
                m: 0,
                ml: 2,
                justifyContent: "space-between",
                "& .MuiSvgIcon-root": {
                  fontSize: "28px !important",
                  color: "#37B34A !important",
                  mr: "0px !important",
                },
              }}
              // onChange={(e) => {
              //   const allPerson = personName.includes(name);
              //   if (allPerson) {
              //     const dat = personName.filter(
              //       (n) => n.entity.id !== name?.entity.id
              //     );
              //     setPersonName([...dat]);
              //   } else {
              //     setPersonName((v) => [...v, name]);
              //   }
              // }}
               onChange={(e) => handleCollectorName(e, name)}
            />
            <Checkbox
              checked={entitiesFavorites.find(
                (f) => 
                   f.favorites.entityId === name?.entity.entityId &&
                   f.favorites.status === EntityFavoriteStatus.favorite
              )}
              icon={<FavoriteBorder />}
              checkedIcon={<Favorite/>}
              color="warning"
              onChange={(e) => {
                const data = {
                  id: entitiesFavorites.find(
                    (f) => f.favorites.entityId === name?.entity.entityId
                  )
                    ? entitiesFavorites.find(
                        (f) => f.favorites.entityId === name?.entity.entityId
                      ).favorites.id
                    : 0,
                  entityId: name?.entity.entityId,
                  status: e.target.checked ? EntityFavoriteStatus.favorite : "",
                  updatedBy: userId,
                };
                dispatch(addEntityFavorite(data))
                  .unwrap()
                  .then((res) => {
                    getFavoriteEntities();
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }}
            />
          </MenuItem>
        ))}
      {!loading && searchFavoriteEntities.length === 0 && (
        <Typography variant="body1" fontFamily={"Poppins"} textAlign={"center"}>
          {t("noEntites")}
        </Typography>
      )}
    </>
  );
};

export default FavoriteEntity;
